// Types for local installation calculations
export var InstallationType;
(function (InstallationType) {
    InstallationType["CombinedHeatAndPowerInstallation"] = "KWK-Anlage (Kraft-W\u00E4rme-Kopplung)";
    InstallationType["PowerPlant"] = "Kraftwerk";
    InstallationType["RenewableEnergyLawInstallation"] = "EEG-Anlage (Erneuerbare-Energien-Gesetz)";
    InstallationType["HeatGenerationInstallation"] = "W\u00E4rmeerzeugungsanlage";
    InstallationType["HeatingPlant"] = "Heizwerk";
})(InstallationType || (InstallationType = {}));
